"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gen5_datamapping_lib_1 = require("@terragotech/gen5-datamapping-lib");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const PageContexts_1 = require("./Contexts/PageContexts");
const GroupComponent_1 = __importDefault(require("./PageComponents/GroupComponent"));
const InputFieldComponent_1 = require("./PageComponents/InputFieldComponent");
const MediaComponent_1 = require("./PageComponents/MediaComponent");
const TextHeader_1 = require("./PageComponents/TextHeader");
const MapComponent_1 = require("./PageComponents/MapComponent");
const PageRenderer_1 = __importDefault(require("./PageRenderer"));
const StreetViewComponent_1 = require("./PageComponents/StreetViewComponent");
const deep_diff_1 = __importDefault(require("deep-diff"));
// const accessors = { METADATA: () => ({ timePageOpened: new Date() }), STATE: () => ({}) };
const PageComponent = react_1.default.memo(props => {
    const { template, dataMappingContext, defaultDateTimeFormat, forceOneLine, forceOneColumn, disableStreetView, isDesktopCard, noMargin, loader, render } = props;
    // const { accessors } = usePageDataMappingSources();
    // use Memo here might reduce some rendering;
    const [localAccessors, setLocalAccessors] = (0, react_1.useState)(dataMappingContext.accessors);
    const [lastAccessors, setLastAccessors] = (0, react_1.useState)(null);
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    const [needsInit, setNeedsInit] = (0, react_1.useState)(false);
    const { pageState, setPageState } = (0, PageContexts_1.usePageState)();
    const renderPage = (0, react_1.useCallback)(() => (react_1.default.createElement(PageRenderer_1.default, { forceOneLine: forceOneLine, forceOneColumn: forceOneColumn, defaultDateTimeFormat: defaultDateTimeFormat, template: template, values: pageState, accessors: localAccessors, disableStreetView: disableStreetView, isDesktopCard: isDesktopCard, noMargin: noMargin })), [
        template,
        pageState,
        localAccessors,
        defaultDateTimeFormat,
        forceOneColumn,
        forceOneLine,
        disableStreetView,
        isDesktopCard,
        noMargin,
    ]);
    const [initialValuesRan, setInitialValuesRan] = (0, react_1.useState)(false);
    //set the initialDataMap, but only if it's not been done before
    (0, react_1.useEffect)(() => {
        if (localAccessors !== dataMappingContext.accessors && !lodash_1.default.isEmpty(dataMappingContext.accessors)) {
            setLocalAccessors(dataMappingContext.accessors);
        }
    }, [dataMappingContext.accessors, localAccessors]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!lodash_1.default.isEmpty(localAccessors) &&
            (initialValuesRan === false || !!deep_diff_1.default.diff((_a = localAccessors === null || localAccessors === void 0 ? void 0 : localAccessors.STATE) === null || _a === void 0 ? void 0 : _a.call(localAccessors), (_b = lastAccessors === null || lastAccessors === void 0 ? void 0 : lastAccessors.STATE) === null || _b === void 0 ? void 0 : _b.call(lastAccessors)))) {
            setInitialValuesRan(true);
            setLastAccessors(localAccessors);
            if (template.initialDataMap) {
                gen5_datamapping_lib_1.mapScenarios.INITIAL_DATA_MAPPING.evaluate(template.initialDataMap, localAccessors, props.functionDefinitions).then(result => {
                    setPageState(Object.assign({}, result));
                    setLoaded(true);
                    setNeedsInit(true);
                });
            }
            else {
                setLoaded(true);
            }
        }
    }, [
        initialValuesRan,
        localAccessors,
        props.functionDefinitions,
        template.initialDataMap,
        lastAccessors,
        setPageState,
    ]);
    (0, react_1.useEffect)(() => {
        if (needsInit) {
            setNeedsInit(false);
        }
    }, [needsInit]);
    // We wait to render our first time until we have calculated our initial values, this is because
    //   changing them after the first render has no effect in final-form
    return loaded && !needsInit ? render({ renderPage }) : loader ? loader() : null;
});
PageComponent.displayName = 'PageComponent';
const initPageRootRenderer = (controlProvider) => {
    /**
     * This function takes a list of the controls to build and builds the output controls using the typical
     * form control capabilities(repeatable, conditional, validated and read only )
     * @param componentNames names of all controls to build
     */
    const buildTypicalInputControls = (componentNames) => {
        return componentNames.reduce((acc, componentName) => {
            return Object.assign(Object.assign({}, acc), { [componentName]: (0, InputFieldComponent_1.generateInputFieldComponent)(controlProvider, componentName) });
        }, {});
    };
    /**
     * Similar to above, this builds input controls, though this also includes access to the file management
     * props
     * @param componentNames names of media/file controls to buile
     */
    const buildFileControls = (componentNames) => {
        return componentNames.reduce((acc, componentName) => {
            return Object.assign(Object.assign({}, acc), { [componentName]: (0, MediaComponent_1.generateMediaComponent)(controlProvider, componentName) });
        }, {});
    };
    // Build out the full control map, wrapping our handler code around the UI code provided by the consumer
    const controlMap = Object.assign(Object.assign(Object.assign({}, buildTypicalInputControls([
        'currency',
        'computed',
        'date',
        'dateinput',
        'location',
        'polyline',
        'number',
        'numberinput',
        'textArea',
        'text',
        'time',
        'textinput',
        'timeinput',
        'datetime',
        'link',
        'list',
        'chart',
        'select',
        'multiselect',
    ])), buildFileControls(['image', 'file'])), { aggregateMap: controlProvider.aggregateMap ? (0, MapComponent_1.generateMapComponent)(controlProvider) : undefined, textheader: controlProvider.textheader ? (0, TextHeader_1.generateTextHeader)(controlProvider) : undefined, group: GroupComponent_1.default, RootWrapper: controlProvider.RootWrapper, RepeatWrapper: controlProvider.RepeatWrapper, GroupWrapper: controlProvider.GroupWrapper, GridElementWrapper: controlProvider.GridElementWrapper, GridWrapper: controlProvider.GridWrapper, StyleWrapper: controlProvider.StyleWrapper, streetView: controlProvider.streetView ? (0, StreetViewComponent_1.generateStreetViewComponent)(controlProvider) : undefined });
    /**
     * The PageComponent is the primary component used to render the form. It is created after the initPageRootRenderer
     * builds it using the passed in control map
     * @param onSubmit called by react final form when the form is submitted
     * @param render render prop called with the form, warnings, errors, etc
     * @param template the template to render
     */
    const PageRootRenderer = props => {
        const { dataMappingContext } = props, rest = __rest(props, ["dataMappingContext"]);
        const value = (0, react_1.useMemo)(() => {
            return {
                controlMap,
                functionDefinitions: props.functionDefinitions,
                mainColumns: rest.forceOneColumn || rest.template.columns,
            };
        }, [props.functionDefinitions, rest.forceOneColumn, rest.template.columns]);
        return (react_1.default.createElement(PageContexts_1.FieldValidationContextProvider, null,
            react_1.default.createElement(PageContexts_1.FileManagementContextProvider, null,
                react_1.default.createElement(PageContexts_1.PageStateContextProvider, null,
                    react_1.default.createElement(PageContexts_1.ControlProviderContext.Provider, { value: value },
                        react_1.default.createElement(PageContexts_1.PageDataMappingContext.Provider, { value: dataMappingContext },
                            react_1.default.createElement(PageComponent, Object.assign({}, rest, { dataMappingContext: dataMappingContext }))))))));
    };
    return PageRootRenderer;
};
exports.default = initPageRootRenderer;
